import { render, staticRenderFns } from "./GlobalNavigation.vue?vue&type=template&id=1356b0f5&"
import script from "./GlobalNavigation.vue?vue&type=script&lang=js&"
export * from "./GlobalNavigation.vue?vue&type=script&lang=js&"
import style0 from "./GlobalNavigation.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports